import { withStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

import styles from '../../../../../../styles/modals.module.scss';
import Button from '../../../../../../components/Buttons/Button';
import Modal from '../../../../../../components/Modals/Modal';
import ModalAlert from '../../../../../../components/Modals/ModalAlert';
import {
  emailVerification,
  phonenumberVerification,
  textVerification,
} from '../../../../../../utils/formValdations';

import { findPhoneNumbersInText } from 'libphonenumber-js';
import TextInput from '../../../../../../components/Inputs/TextInput';
import PhoneInput from '../../../../../../components/Inputs/PhoneInput';
import SquareEdit from '../../../../../../components/SquareEdit/SquareEdit';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import SButton from '../../../../../../components/SButton/SButton';
import SDialog from '../../../../../../components/SDialog/SDialog';
import Typography from '../../../../../../components/Typography/Typography';

// import EditCustomerAdminPopup from './EditCustomerAdminPopup';
// import EditCustomerAdminPopup from './EditCustomerAdminPopup';

const errorText = 'Please enter a valid';

const HandOverPopup = ({ showModal, closeModal, onClick, adminData, handleUpdateAdmin }) => {
  const [showHandoverWarning, setShowHandoverWarning] = useState(false);
  const [adminName, setAdminName] = useState({ value: '', error: '' });
  const [adminEmail, setAdminEmail] = useState({ value: '', error: '' });
  const [adminPhoneNumber, setAdminPhoneNumber] = useState({ value: '', error: '' });
  const [countryCode, setCountryCode] = useState('91');
  const [mode, setMode] = useState('add');

  // const [showEditModal, setShowEditModal] = useState(false);
  const WhiteTextTypography = withStyles({
    root: {
      color: '#483f94',
    },
  })(Typography);

  const boxStyle = {
    border: '1px solid #D3D3D3',
    borderRadius: '8px',
    padding: '20px',
    marginTop: '12px',
  };

  const handleClick = () => {
    setShowHandoverWarning(true);
  };

  const patchAdminData = () => {
    setAdminName({ error: '', value: adminData?.name || '' });
    setAdminEmail({ error: '', value: adminData?.email || '' });
    try {
      const mobileNumber = findPhoneNumbersInText(adminData?.phone)[0];

      const { number } = mobileNumber;
      setCountryCode(number?.countryCallingCode || '91');
      setAdminPhoneNumber({ error: '', value: number?.nationalNumber || '' });
    } catch (error) {
      setAdminPhoneNumber({ error: '', value: adminData.phone || '' });
    }
  }

  useEffect(() => {
    if (adminData) {
      patchAdminData()
    }
  }, [adminData]);

  const handleSubmit = () => {
    onClick();
    setShowHandoverWarning(false);
    closeModal();
  };
  const handleSubmitEdit = () => {
    const phoneNumber = `+${countryCode}${adminPhoneNumber.value}`;
    const payload = {
      name: adminName.value,
      phone: phoneNumber,
      email: adminEmail.value,
      adminType: 2,
    };

    handleUpdateAdmin(payload);
    closeModal();
  };

  const handleChange = (e) => {
    const { name, value } = e?.currentTarget;

    let error = '';
    switch (name) {
      case 'adminName':
        error = textVerification(value, 2) ? `${errorText} admin name` : '';
        setAdminName({ value, error });
        break;
      case 'adminEmail':
        error = !emailVerification(value) ? `${errorText} admin email` : '';
        setAdminEmail({ value, error });
        break;
      case 'adminPhoneNumber':
        error = !phonenumberVerification(`+${countryCode}${value}`)
          ? `${errorText} phone number`
          : '';
        setAdminPhoneNumber({ value, error });
        break;

      default:
        break;
    }
  };

  const disabled = useMemo(() => {
    if (adminEmail.value === '' || adminName.value === '' || adminPhoneNumber.value === '') {
      return true;
    }
    if (adminEmail.error !== '' || adminName.error !== '' || adminPhoneNumber.error !== '') {
      return true;
    }
    return false;
  }, [adminEmail, adminName, adminPhoneNumber])

  return (
    <>
      <SDialog
        title={mode === 'add' ? 'Handover Organisation' : 'Edit super admin details'}
        open={showModal}
        onClose={closeModal}
        titleConfig={{
          variant: 'h5M'
        }}
        isFormDialog={true}
        secondaryButtonConfig={{
          text: 'Cancel',
          onClick: mode === 'add' ? () => {
            patchAdminData();
            closeModal();
          } : () => {
            setMode('add');
            patchAdminData();
          }
        }}
        primaryButtonConfig={{
          text: mode === 'add' ? 'Handover' : 'Save',
          onClick: mode === 'add' ? handleClick : handleSubmitEdit,
          disabled: mode === 'add' ? false : disabled
        }}
      >
        <FlexColumn alignItems='start'>
          {mode === 'add' ? (
            <>
              <Typography variant='b3M' color='var(--brand-700)'>Once handover is complete partner admin will be deleted and replaced by customer
                super admin. Please confirm super admin details before handover</Typography>
              <FlexColumn alignItems='start' styles={boxStyle}>
                <FlexRow justifyContent='space-between'>
                  <Typography variant="b2M" color='var(--grey-900)'>
                    {adminData?.name}
                  </Typography>
                  <SquareEdit
                    color={'#ff535a'}
                    onPress={() => {
                      setMode('edit');
                    }}
                    style={{ height: '30px', width: '30px' }}
                  />
                </FlexRow>
                <FlexRow justifyContent='space-between'>
                  <Typography variant="b2R" color='var(--grey-500)'>
                    Phone : {adminData?.phone}
                  </Typography>
                  <Typography variant="b2R" color='var(--grey-500)'>
                    Email : {adminData?.email}
                  </Typography>
                </FlexRow>
              </FlexColumn>
            </>
          ) : (
            <>
              <Typography variant='b3M' color='var(--brand-700)'>Enter super admin details. Initiate handover once user signs up</Typography>
              <FlexColumn styles={boxStyle}>
                <FlexRow justifyContent='start'>
                  <TextInput
                    name="adminName"
                    placeholder="Admin Name"
                    value={adminName.value}
                    onChange={handleChange}
                    disabled={false}
                    error={adminName.error}
                  />
                  <PhoneInput
                    name="adminPhoneNumber"
                    placeholder="Admin Phone Number"
                    type="number"
                    defaultCountryCode={countryCode}
                    value={adminPhoneNumber.value}
                    onChange={handleChange}
                    disabled={false}
                    error={adminPhoneNumber.error}
                    handleCountryCode={(code) => setCountryCode(code)}
                  />
                </FlexRow>
                <TextInput
                  name="adminEmail"
                  placeholder="Admin Email Address"
                  type="email"
                  value={adminEmail.value}
                  onChange={handleChange}
                  disabled={false}
                  error={adminEmail.error}
                />
              </FlexColumn>
            </>
          )}
        </FlexColumn>
      </SDialog>
      {showHandoverWarning && (
        <SDialog
          title='Warning!'
          open={showHandoverWarning}
          onClose={() => {
            setShowHandoverWarning(false);
          }}
          titleConfig={{
            variant: 'h5M'
          }}
          secondaryButtonConfig={{
            text: 'Cancel',
            onClick: () => {
              setShowHandoverWarning(false);
            }
          }}
          primaryButtonConfig={{
            text: 'Continue',
            onClick: handleSubmit
          }}
        >
          <Typography variant={"b2M"} style={{ padding: '1.5rem 0' }}>Once handover is complete partner admin  will lose all access to the organisation and will be deleted from the organisation. Are you sure you want to continue?</Typography>
        </SDialog>
      )}
    </>
  );
};

export default HandOverPopup;
